// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nUh2","question":"styles_question__2jWPN","description":"styles_description__cDGc7"};